import NewCard from './NewCard';
export default NewCard;
